<template>
	<div class="spaceselect level-left">
		<ui-select
                label=""
                placeholder="Select Space"
                :options="spaceList"
                v-model="selectedSpace"
                @select="spaceSelected"

            ></ui-select>
	</div>
</template>

<script>
import UiSelect from 'keen-ui/src/UiSelect.vue';
import { EventBus } from '../../store/eventbus.js'

export default {
	name: 'spaceconfig',
	components: {UiSelect},
	data () {
		return {
			selectedSpace: "",
			created: false
		}
	},
	created(){

		// Perhaps put that somewhere else, but for now leave it here
		let _this = this;
		const debouncedSync = _.debounce(function(){
			_this.syncAll();
		},2000,{
		  'leading': true,
		  'trailing': false
		})
		debouncedSync();
		EventBus.$on('db:change:elements', change => {
			console.log("listen! Elements DB HAS CHANGED", change)
			_this.$store.dispatch('sync','elements').then(()=>{
				// in this case the get is dependent on the sync
				_this.$store.dispatch('getListFromLocal','elements');
			})
		});

		EventBus.$on('db:reconnected', () => {
			console.log("listen! RECONNECT")
			debouncedSync();
		});

		EventBus.$on('db:unavailable', () => {
			console.log("listen! PUSHER UNAVAILABLE")
			//_this.syncAll();
		});

		EventBus.$on('db:change:element_types', change => {
			console.log("listen! Element Types DB HAS CHANGED", change)
			_this.$store.dispatch('sync','element_types').then(()=>{
				// in this case the get is dependent on the sync
				_this.$store.dispatch('getListFromLocal','element_types');
			})
		});

		EventBus.$on('db:change:spaces', change => {
			console.log("listen! Spaces DB HAS CHANGED - spaces", change)
			_this.$store.dispatch('sync','spaces').then(()=>{
				// in this case the get is dependent on the sync
				_this.$store.dispatch('getListFromLocal','spaces').then(()=>{
					if(_this.$store.state.currentSpace){
						console.log("set current space to synced space");
						_this.$store.dispatch('setCurrentSpace',{value: _this.$store.state.currentSpace.id});
					}
				});
			})
		});
	},
	computed: {
		spaces(){
			return this.$store.state.spaces.data
		},
		spaceList(){
			const spaceList = [];
			// reset active statuses
			let $this = this;
			spaceList.push({'label':'Show all','value':0});
			_.forIn(this.spaces, function(space) {
				let s = {
					'label': space.name,
					'value': space.id
				}
				spaceList.push(s);
			});
			return spaceList;
		}
	},

	methods: {
		spaceSelected(){
			console.log("space selected",this.selectedSpace);
			this.$store.dispatch('setCurrentSpace', this.selectedSpace);
		},
		syncAll(){
			let _this = this;
			console.log("TEST _ ", _.map(this.spaces,'id'));
			_this.$store.dispatch('sync','elements').then(()=>{
				// in this case the get is dependent on the sync
				_this.$store.dispatch('getListFromLocal','elements');
			});
			_this.$store.dispatch('sync','spaces').then(()=>{
				// in this case the get is dependent on the sync
				_this.$store.dispatch('getListFromLocal','spaces').then(()=>{
					if(_this.$store.state.currentSpace){
						console.log("set current space to synced space");
						_this.$store.dispatch('setCurrentSpace',{value: _this.$store.state.currentSpace.id});
					}
				});
			});
			_this.$store.dispatch('sync','element_types').then(()=>{
				// in this case the get is dependent on the sync
				_this.$store.dispatch('getListFromLocal','element_types');
			})
		},
		test(){
			console.log("TEST CALL METHOD")
		}
	},
	mounted(){
		console.log("mounted spaceselect")
		//this.$store.dispatch('setCurrentSpace', this.selectedSpace);
	}
}
</script>

<style lang="stylus">
@import '../../styles/colors.stylus'
.spaceselect
	height 100%
	width 200px
	background rgba(255,255,255,0.25)
	padding 0 20px
	text-transform uppercase
	.ui-select
		margin 0
		height 100%
		align-items center
		width 200px
	.ui-select__display
		color white
		border none
	.ui-select__display-value
		text-transform uppercase
		font-size 0.875rem
		font-weight 600
	.ui-select__dropdown-button
		color white
	.ui-select__display-value.is-placeholder
		color white
</style>



// WEBPACK FOOTER //
// Spaceselect.vue?d30e08d4